import { useEffect } from 'react'
import { WbsItemType } from '../../../domain/entity/WbsItemEntity'
import { Task } from './components/pages/Task'
import { Deliverable } from './components/pages/Deliverable'
import { useDispatch, useSelector } from 'react-redux'
import { DeliverableList } from './components/pages/DeliverableList'
import { Process } from './components/pages/Process'
import { Ticket } from './components/pages/Ticket'
import { WbsItemTypeVO } from '../../../domain/value-object/WbsItemTypeVO'
import { loginToProject } from '../../../store/project'
import { useEditingTicketBasic, useWbsItemBasic } from './hooks/wbsItemBasic'
import { useApplicationFunctionUuid } from './hooks/applicationFunctionUuid'
import { TicketInitialValue } from './model/ticket'
import { AllState } from '../../../store'
import TextVO from '../../../vo/TextVO'
import DateRangeVO from '../../../vo/DateRangeVO'
import EntitySearchVO from '../../../vo/EntitySearchVO'
import MultiEntitySearchVO from '../../../vo/MultiEntitySearchVO'
import NumberVO from '../../../vo/NumberVO'
import SelectVO from '../../../vo/SelectVO'
import TagVO from '../../../vo/TagVO'
import { TableData } from '../../containers/SingleSheet/DataTable'

export class WbsItemData extends TableData {
  code?: TextVO
  displayName?: TextVO
  type?: SelectVO
  status?: SelectVO
  substatus?: SelectVO
  ticketType?: string
  team?: EntitySearchVO
  accountable?: EntitySearchVO
  responsible?: EntitySearchVO
  assignee?: EntitySearchVO
  difficulty?: SelectVO
  priority?: SelectVO
  estimatedHour?: NumberVO
  scheduledDate?: DateRangeVO
  actualDate?: DateRangeVO

  watchers?: MultiEntitySearchVO
  wbsItemType?: WbsItemTypeVO
  sprint?: EntitySearchVO
  tags?: TagVO

  projectUuid?: string

  getCode() {
    return this.code
  }

  getName() {
    return this.displayName
  }
}

type FunctionLayerProps = {
  // Re-consider how to implement.
  functionLayerDepth: number
  auxiliaries?: {
    editingTicket: TicketInitialValue
  }
}
type Props = {
  code: string
} & FunctionLayerProps
export type WbsItemProps = {
  projectUuid: string
  wbsItemType: WbsItemTypeVO
  uuid: string
  functionUuid: string
} & FunctionLayerProps
export type TicketProps = {
  ticketType: string
  ticketInitialValue?: TicketInitialValue
} & WbsItemProps

export const WbsItem = ({ code, functionLayerDepth, auxiliaries }: Props) => {
  const dispatch = useDispatch()
  const editingTicket = auxiliaries?.editingTicket
  const editingTicketBasic = useEditingTicketBasic(auxiliaries?.editingTicket)
  const basic = useWbsItemBasic(code, editingTicketBasic)
  const functionUuid = useApplicationFunctionUuid(basic)
  const projectUuid = useSelector((state: AllState) => state.project.selected)

  useEffect(() => {
    if (basic && projectUuid !== basic?.projectUuid) {
      dispatch(loginToProject(basic.projectUuid))
    }
  }, [basic, dispatch, projectUuid])

  if (!basic || !projectUuid || basic.projectUuid !== projectUuid) return <></>

  const { uuid, type, ticketType, typeVo } = basic
  switch (type) {
    case WbsItemType.TASK:
      if (!!ticketType) {
        return (
          <Ticket
            projectUuid={basic.projectUuid}
            wbsItemType={typeVo}
            uuid={uuid}
            functionUuid={functionUuid}
            ticketType={ticketType}
            functionLayerDepth={functionLayerDepth}
            ticketInitialValue={editingTicket}
          />
        )
      }
      return (
        <Task
          projectUuid={basic.projectUuid}
          wbsItemType={typeVo}
          uuid={uuid}
          functionUuid={functionUuid}
          functionLayerDepth={functionLayerDepth}
        />
      )
    case WbsItemType.DELIVERABLE:
      return (
        <Deliverable
          projectUuid={basic.projectUuid}
          wbsItemType={typeVo}
          uuid={uuid}
          functionUuid={functionUuid}
          functionLayerDepth={functionLayerDepth}
        />
      )
    case WbsItemType.DELIVERABLE_LIST:
      return (
        <DeliverableList
          projectUuid={basic.projectUuid}
          wbsItemType={typeVo}
          uuid={uuid}
          functionUuid={functionUuid}
          functionLayerDepth={functionLayerDepth}
        />
      )
    case WbsItemType.PROCESS:
      return (
        <Process
          projectUuid={basic.projectUuid}
          wbsItemType={typeVo}
          uuid={uuid}
          functionUuid={functionUuid}
          functionLayerDepth={functionLayerDepth}
        />
      )
  }
  return <></>
}
